const reducer = (state = '/MainLanding', action) =>{
    switch(action.type){
        case "setBackPath": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  